
import { georgeBio, jerryBio, kramerBio } from './elaineBios'
import { georgeReviewerReviewHinge, jerryReviewerReviewBumble, kramerReviewerReviewTinder } from './elaineReviewerReviews'

export const georgeReviewerProfile = {
  _id: 'georgeReviewerProfileId',
  userId: 'georgeUserId',
  email: 'george@email.com',
  profilePicture: 'https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-george-17-sq.png',
  isVisible: true,
  isCoach: false,
  isAIReviewer: false,
  isHotty: true,
  isFeatured: false,
  reviewRate: 50,
  nameOfLLM: `NA`,
  openAIAssistantID: `NA`,
  bio: { ...georgeBio },
  profileReviews: [
    // { ...georgeProfileReviewHinge }
  ],
  reviewerReviews: [
    { ...georgeReviewerReviewHinge }
  ],
}

export const jerryReviewerProfile = {
  _id: 'jerryReviewerProfileId',
  userId: 'jerryUserId',
  email: 'jerry@email.com',
  profilePicture: 'https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-jerry-1-sq.jpg',
  isVisible: true,
  isCoach: false,
  isAIReviewer: true,
  isHotty: false,
  isFeatured: false,
  reviewRate: 50,
  nameOfLLM: `Open AI gpt4o mini`,
  openAIAssistantID: `NA`,
  bio: { ...jerryBio },
  profileReviews: [
    // { ...jerryProfileReviewBumble }
  ],
  reviewerReviews: [
    { ...jerryReviewerReviewBumble }
  ],
}

export const kramerReviewerProfile = {
  _id: 'kramerReviewerProfileId',
  userId: 'kramerUserId',
  email: 'kramer@email.com',
  profilePicture: 'https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-kramer-5-sq.png',
  isVisible: true,
  isCoach: false,
  isAIReviewer: false,
  isHotty: true,
  isFeatured: false,
  reviewRate: 50,
  nameOfLLM: `NA`,
  openAIAssistantID: `NA`,
  bio: { ...kramerBio },
  profileReviews: [
    // { ...kramerProfileReviewTinder }
  ],
  reviewerReviews: [
    { ...kramerReviewerReviewTinder }
  ],
}